import { Link } from "react-router-dom";

export default function DoctorDescription () {

    return <>
        <h1>
            Dr. Sandeep Samson
        </h1>
        <h5>Surgeon at somewhere</h5>

        <p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p>

        <Link to={"/userLogin"}>Pay ₹49 and speak to Dr. Sandeep</Link>
    </>
}
